import { Route, RouteGroup } from '@billow/easy-route'

export default RouteGroup({
  
  middleware: ['auth'],

  routes: [
    Route('/plans', 'plans', () => import('@/views/account/SelectPlan.vue')),
    Route('/account', 'account', () => import('@/views/account/Overview.vue')),
  ]
})